/** Height (in px) of the fixed Navbar in its normal state. */
export const NAVBAR_HEIGHT = 56;

/**
 * Height (in px) of the "Exit Organization" strip Navbar renders above its
 * Toolbar while a superadmin is impersonating an organization.
 */
export const IMPERSONATION_BANNER_HEIGHT = 36;
